module.exports = __webpack_public_path__ + "static/gravida-exercicio-2-8461a8156373a5eb7513cedee2428708.jpg";